/**
 * Tên dự án LUÔN được suy ra từ hai đối tượng đem so sánh: "<A> VS <B>".
 *
 * Trước đây tên là một ô nhập tự do nên người dùng gõ thêm phần mô tả ở đuôi
 * (ví dụ "... — Phân Biệt & Dùng Thuốc Đúng Cách"). Hệ quả: tên dài lê thê,
 * tràn nhiều dòng ở sidebar, và không còn khớp với nội dung video vốn chỉ
 * đặt A cạnh B. Suy ra tên từ chính hai đối tượng thì tên luôn ngắn, luôn
 * đúng, và tự đổi theo khi người dùng sửa đối tượng.
 */

export const FALLBACK_PROJECT_NAME = 'Video So Sánh Mới';

export function buildProjectName(subjectA, subjectB, fallback = FALLBACK_PROJECT_NAME) {
  const a = String(subjectA?.name || '').trim();
  const b = String(subjectB?.name || '').trim();

  if (a && b) return `${a} VS ${b}`;
  // Mới điền một bên (đang gõ dở ở Bước 1) thì hiển thị tạm bên đã có.
  return a || b || fallback;
}

export default buildProjectName;
